import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('notifications')

export const FETCH_CONVO_FOR_PARTICIPANT_NOTIFICATION = makeConstant('FETCH_CONVO_FOR_PARTICIPANT_NOTIFICATION')

export const SW_REGISTRATION_SUCCESS = makeConstant('SW_REGISTRATION_SUCCESS')
export const SW_REGISTRATION_FAILED = makeConstant('SW_REGISTRATION_FAILED')
export const SERVICE_WORKER_MESSAGE = makeConstant('SERVICE_WORKER_MESSAGE')

export const NOTIFICATION_SOUND_SUCCESS = makeConstant('NOTIFICATION_SOUND_SUCCESS')
export const NOTIFICATION_SOUND_FAILED = makeConstant('NOTIFICATION_SOUND_FAILED')

export const SHOW_ABM_MODAL = makeConstant('SHOW_ABM_MODAL')
export const SHOW_ABM_MODAL_FAILED = makeConstant('SHOW_ABM_MODAL_FAILED')


// WEBPACK FOOTER //
// ./src/scripts/app/modules/notification/constants.js